<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/lxwm/dean">给院长写信</router-link>
    </div>
    <div class="container-width">
      <ARTICLE :current="current" :page="currentPage"></ARTICLE>
      
    </div>
  </div>
</template>
<script>
import service from "../../../service/lxwm";
import BANNER from "../../../components/banner/lxwm";
export default {
  name: "dean",
  data() {
    return {
      navigationData: [
        {
          name: "给院长写信",
          path: "/lxwm/dean",
        },
        // {
        //   name: "来信统计",
        //   path: "/lxwm/letters",
        // },
        // {
        //   name: "来信选登",
        //   path: "/lxwm/digest",
        // },
        // {
        //   name: "来信回复",
        //   path: "/lxwm/reply",
        // },
        {
          name: "纪检监察",
          path: "/lxwm/discipline",
        },
      ],
      currentPath: "/lxwm/dean",
      current: {
        title: "",
        description: "",
      },
      currentPage: "dean",
    };
  },
  components: { BANNER },
  computed: {},
  created() {
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      service.getDeanLetter({}, (res) => {
        this.current = { ...res };
      });
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style>
</style>
